import * as React from 'react';
import { DataSignal } from 's-js';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { Error } from 'lib/validationWatcher';

import {
    VALIDATION_TOKEN,
    VALIDATION_ALREADY_ACTIVE,
    VALIDATION_DEACTIVATED_ORG,
    VALIDATION_DEACTIVATED_USER
} from './invitationerrors';

import { ProfileAndLandingPageLinks, HomepageLink, WithUser } from './invitationlinks';

interface WithShowLogin {
    ShowLogin : DataSignal<boolean>;
}

interface CommonInvitationErrorsViewProps {
    model : WithUser & WithShowLogin;
    getError : ErrorGetter;
    tokenErrorText : string;
}

interface ErrorGetter {
    (key : string) : Error | undefined;
}

export const CommonInvitationErrorsView = SuperCritical(({ model: m, getError, tokenErrorText } : CommonInvitationErrorsViewProps) =>
    <div>
        <TokenErrorView model={m} getError={getError} tokenErrorText={tokenErrorText} />
        <DeactivatedOrgErrorView getError={getError} />
        <DeactivatedUserErrorView getError={getError} />
        <AlreadyActiveErrorView model={m} getError={getError} />
    </div>
);

let TokenErrorView = SuperCritical(({ model: m, getError, tokenErrorText } : {
    model : WithShowLogin,
    getError : ErrorGetter,
    tokenErrorText : string
}) => {
    const tokenError = getError(VALIDATION_TOKEN);
    if (!tokenError) return null;
    return (
        <div>
            <div className="result-description">
                <div>{tokenError.ErrorText}</div>
                <div>{tokenErrorText}</div>
            </div>
            <div className="link-shell">
                <a href="" onClick={noDefault(() => m.ShowLogin(true))}>Login</a>
            </div>
            <HomepageLink />
        </div>
    );
});

let DeactivatedOrgErrorView = SuperCritical(({ getError } : { getError : ErrorGetter }) => {
    const deactivatedOrgError = getError(VALIDATION_DEACTIVATED_ORG);
    if (!deactivatedOrgError) return null;
    return (
        <div>
            <div className="result-description">{deactivatedOrgError.ErrorText}</div>
            <HomepageLink />
        </div>
    );
});

let DeactivatedUserErrorView = SuperCritical(({ getError } : { getError : ErrorGetter }) => {
    const deactivatedUserError = getError(VALIDATION_DEACTIVATED_USER);
    if (!deactivatedUserError) return null;
    return (
        <div>
            <div className="result-description">{deactivatedUserError.ErrorText}</div>
            <HomepageLink />
        </div>
    );
});

let AlreadyActiveErrorView = SuperCritical(({ model: m, getError } : { model : WithUser, getError : ErrorGetter }) => {
    const alreadyActiveError = getError(VALIDATION_ALREADY_ACTIVE);
    if (!alreadyActiveError) return null;
    return (
        <div>
            <div className="result-description">{alreadyActiveError.ErrorText}</div>
            <ProfileAndLandingPageLinks model={m} />
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/invitationerrorsview.tsx